@if (filteredProducts$ | async; as products) {
   @if (products.length > 0) {
      <div class="py-5">
         <siko-b2b-carousel
            id="js--last-seen-products-tab"
            [products]="products"
            [title]="'pdp.tabs.lastSeen' | cxTranslate"
         />
      </div>
   }
}
